export const validationSettings = {
  parse: 'Введите число',
  required: 'Введите этаж',
  min: 'Этаж должен быть больше',
  max: 'Допустимо не более 3 символов',
  notZero: 'Введите -1 или -2 для подвала или полу-подвала',
};
